import { toast } from "react-toastify"
import api from "../../services/api"
import bootstrapBundleMin from "bootstrap/dist/js/bootstrap.bundle.min"
import { useLoading } from "../../hooks/useLoading"
import { Spinner } from "react-bootstrap"

export function ResetSupplierModal({ supplierRegistered }) {
  const loading = useLoading()

  async function handleResetSupplier() {
    try {
      if (!supplierRegistered) return

      loading.setLoading(true)
      const data = {
        email: supplierRegistered.email,
        cpf_cnpj: supplierRegistered.cpfcnpj,
        usuario: supplierRegistered.usuario,
        empresa: supplierRegistered.empresa
      }

      const response = await api.post(`/v1/reseta_fornecedor_api/`, data)

      if (response.request.status === 400) {
        const jsonResponse = JSON.parse(response.request.response)
        const errorMessage = jsonResponse.error
        toast.error(errorMessage)
        loading.setLoading(false)
        return
      }

      const successMessage = response.data.success
      toast.success(successMessage)
      loading.setLoading(false)

      const modal = document.getElementById('resetUser')
      const modalInstance = bootstrapBundleMin.Modal.getInstance(modal);
      modalInstance.hide();

    } catch (err) {
      loading.setLoading(false)

      if (err.response) {
        console.log(err.response.data.error);
        toast.error(err.response.data.error)
        return
      }

      console.log(err.message);
      toast.error(err.message)
    }
  }
  return (
    <div
      className="modal fade"
      id="resetUser"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="resetUser"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="resetUser">Resetar Cadastro</h1>
            <button type="button" className="btn btn-close" data-bs-dismiss="modal" aria-label="Close">
              X
            </button>
          </div>
          <div className="modal-body">
            <p>Deseja resetar o cadastro para o fornecedor:{' '}
              <em>{supplierRegistered?.empresa}</em> e usuário: <em>{supplierRegistered?.usuario}</em>?
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={handleResetSupplier}
              className="btn btn-primary"
              disabled={loading.isLoading}
            >
              {loading.isLoading ? (
                <Spinner animation="border" variant="light" size="sm" />
              ) : (
                'Salvar'
              )}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
